import {cva} from 'class-variance-authority';

export const sectionTagVariants = cva(
  'relative -mt-1 ml-5 inline-flex items-center justify-center px-4 py-1 text-sm font-semibold text-white',
  {
    variants: {
      color: {
        green: 'bg-[var(--chekin-green-800)]',
        blue: 'bg-[var(--chekin-color-brand-blue)]',
      },
    },
    defaultVariants: {
      color: 'green',
    },
  },
);
